import { Box } from '@mui/material';
import React from 'react';

interface IMDCodeProps {
	children: React.ReactNode;
}

const MDCode: React.FC<IMDCodeProps> = ({ children }) => (
	<Box
		data-testid="md-code"
		component="code"
		bgcolor="primary.highlight"
		borderRadius={1}
		px="2px"
		sx={{
			'pre > &': {
				display: 'block'
			}
		}}
	>
		{children}
	</Box>
);

export default MDCode;
